class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle?.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle?.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle?.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle?.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle?.setAttribute('open', true);
    this.mainDetailsToggle?.querySelector("summary").setAttribute("aria-expanded", true);
  }

  close() {
    this.mainDetailsToggle?.removeAttribute("open");
    this.mainDetailsToggle?.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.subnavContainer = this.querySelector("[data-subnav-container]");
    this.subnavTriggers = this.querySelectorAll(
      "[data-megamenu-submenu-trigger]"
    );
    this.closeBackgroundSubnavDetails = "";
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    this.subnavTriggers.forEach((subnavTrigger) => {
      subnavTrigger.addEventListener("mouseenter", (event) => {
        this.closeOpenSubnavDetails(subnavTrigger);
        this.openSubnavDetails(subnavTrigger);
      });

      subnavTrigger.addEventListener("mouseleave", (event) => {
        if (event.toElement.closest('[data-subnav-container]') || event.toElement.hasAttribute('data-subnav-container')) return;

        this.closeSubnavDetails(subnavTrigger);
      });
    });

    let closeMenuDelay = null;

    this.mainDetailsToggle?.addEventListener("mouseenter", (e) => {
      clearTimeout(closeMenuDelay);

      this.header.querySelectorAll('header-menu').forEach(headerMenu => {
        headerMenu.close();
      });

      this.open();
    });
    this.mainDetailsToggle?.addEventListener("mouseleave", (e) => {
      closeMenuDelay = setTimeout(() => {
        this.close();
      }, 1000);
    });
  }

  toggleSubnav(subnavTrigger) {
    let targetSubnavItems = "";

    if (subnavTrigger.hasAttribute('open')) {
      this.closeOpenSubnavDetails(subnavTrigger);

      targetSubnavItems = Array.from(
        subnavTrigger
          .querySelector("[data-megamenu-submenu-container]")
          .cloneNode(true).children
      );
    }

    if (this.closeBackgroundSubnavDetails !== subnavTrigger) {
      this.subnavContainer.replaceChildren(...targetSubnavItems);
    } else {
      this.closeBackgroundSubnavDetails = "";
    }
  }

  openSubnavDetails(subnavDetails) {
    subnavDetails.setAttribute("open", true);

    this.toggleSubnav(subnavDetails);
  }

  closeSubnavDetails(subnavDetails) {
    subnavDetails.removeAttribute("open");

    this.toggleSubnav(subnavDetails);
  }

  closeOpenSubnavDetails(currentSubnavDetails) {
    const openSubnavDetails = currentSubnavDetails
      .closest(".mega-menu__content")
      .querySelectorAll("[data-megamenu-submenu-trigger][open]");

    openSubnavDetails.forEach((subnavDetails) => {
      if (subnavDetails === currentSubnavDetails) {
        return;
      }

      subnavDetails.removeAttribute("open");
      subnavDetails
        .querySelector("summary")
        .setAttribute("aria-expanded", false);

      this.closeBackgroundSubnavDetails = subnavDetails;
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle?.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
